import "./styles/global.scss"
import {htmx} from 'htmx.org'

import { onReady } from "./utils/events/onReady";
import { bootstrapper } from "./utils/bootstrapper";
import { Navigation } from "./components/navigation/navigation";
import { Header } from "./components/header/header";
import { Vimeo } from "./components/video-block/video-block";
import { ArticlesTeaser } from "./components/articles-teaser/articles-teaser";
import { Cards } from "./components/cards/cards";
import { Share } from "./components/share-some/share";
import { Dropdown } from "./components/dropdown/dropdown";
import { Article } from "./components/article/article";
import { Map } from "./components/map/map";
import { CarLoan } from "./components/car-loan/car-loan";
import { News } from "./components/news/news";
import { Blog } from "./components/blog/blog";
import { InfoCard } from "./components/infocard/infocard";
import { BranchOverview } from "./components/branchoverview/branchoverview";
import { Hero } from "./components/hero/hero";
import { Search } from "./components/search/search";
import { BranchPage } from "./components/branch-page/branch-page";
import { Iframe } from "./components/iframe/iframe";
import { Schema } from "./components/schema/schema";
import { MultiVideo } from "./components/multi-video/multi-video";


window.htmx = htmx;


window.addEventListener("htmx:afterSettle", (event) => {
    document.querySelectorAll("[src*=UmbracoForms][src*=App_Plugins]").forEach((el) => {
        let url = new URL(el.src)
        el.src = "";
        el.src = url.origin + url.pathname;
    })
})

const modules = {
    navigation: Navigation,
    header: Header,
    vimeo: Vimeo,
    articlesTeaser: ArticlesTeaser,
    cards: Cards,
    share: Share,
    dropdown: Dropdown,
    article: Article,
    map: Map,
    carLoan: CarLoan,
    news: News,
    blog: Blog,
    infoCard: InfoCard,
    branchOverview: BranchOverview,
    hero: Hero,
    search: Search,
    branchPage: BranchPage,
    iframe: Iframe,
    schema: Schema,
    multiVideo: MultiVideo
};

document.addEventListener("DOMContentLoaded", () => {
    bootstrapper(modules);
});
